import moment from 'moment-timezone';
import 'moment/locale/es';
moment.locale('en')

export function getDayName(dateString: any, language?: any): string {
  const dateInUSTimezone = moment(dateString).tz("America/New_York");
  const days =
    language === "spanish"
      ? [
          "Domingo",
          "Lunes",
          "Martes",
          "Miércoles",
          "Jueves",
          "Viernes",
          "Sábado",
        ]
      : [
          "Sunday",
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday",
        ];
  return days[dateInUSTimezone.day()];
}

interface HelpersType {
  convertUtcToTimezone: (rows: string | Date | moment.Moment, format: string) => string;
  convertInWordTimming: (dateString: string | Date | moment.Moment, format?: string, locale?: string) => string;
  getDayName: typeof getDayName;
}

const Helpers: HelpersType = {
  convertUtcToTimezone: function (rows, format) {
    return moment(rows).format(format);
  },

  convertInWordTimming: (dateString, format='MM-DD-YYYY', locale='en') => {
    const date = moment(dateString).tz('America/New_York');
    return date.locale(locale).format('MMMM Do YYYY');
  },

  getDayName,
};
export default Helpers;
